import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login';
import Portfolios from '@/components/ListPortfolios';
import Advisors from '@/components/AdvisorsTable';
import RegistroGeneral from '@/components/RegisterGeneralData'
import RegistroEmisoras from '@/components/RegisterTransmiters'
import RegistroConfirmacion from '@/components/RegisterConfirmation'
import TestSection from '@/components/TestSection'
import PortfolioOverview from '@/components/PortfolioOverview'
import AssetClassDeuda from '@/components/AssetClassDeuda'
import AssetClassFondosRF from '@/components/AssetClassFondosRF'
import AssetClassFondosRV from '@/components/AssetClassFondosRV'
import AssetClassEstructurados from '@/components/AssetClassEstructurados'
import AssetClassCapitales from '@/components/AssetClassCapitales'
import AssetDetailFondosRV from '@/components/AssetDetailFondosRV'
import AssetDetailFondosRF from '@/components/AssetDetailFondosRF'
import AssetDetailDeuda from '@/components/AssetDetailDeuda'
import AssetDetailCapitales from '@/components/AssetDetailCapitales'
import AssetDetailEstructurados from '@/components/AssetDetailEstructurados'
import PrintablePortfolioAnalysis from '@/components/PrintablePortfolioAnalysis'
import ClientLogin from '@/components/ClientLogin'
import ImportantLinks from '@/components/ImportantLinks'
import Validacion from "../components/Validacion";
import Calculator from "../components/Calculator";
import Calculator_Op1 from "../components/Calculator_Op1";


Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/', // The URL that our router will read
      name: 'Login', // The name that will be show when we inspect our route
      component: Login, // THe name we use to import our element
    },
    {
      path: '/lista-de-analisis',
      name: 'Portfolios',
      component: Portfolios,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/lista-de-asesores',
      name: 'Advisors',
      component: Advisors,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/registro-datos-generales',
      name: 'RegistroGeneral',
      component: RegistroGeneral,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/registro-emisoras',
      name: 'RegistroEmisoras',
      component: RegistroEmisoras,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/registro-confirmacion',
      name: 'RegistroConfirmacion',
      component: RegistroConfirmacion,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/seccion-de-pruebas',
      name: 'TestSection',
      component: TestSection,
    },
    {
      path: '/analisis-portafolio/:id',
      name: 'PortfolioOverview',
      props: { props: true },
      component: PortfolioOverview,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/analisis-portafolio/:id/mercado/deuda',
      name: 'PortfolioAssetClassDeuda',
      component: AssetClassDeuda,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/analisis-portafolio/:id/mercado/fondosrf',
      name: 'AssetClassFondosRF',
      props: { default: true },
      component: AssetClassFondosRF,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/analisis-portafolio/:id/mercado/fondosrv',
      name: 'AssetClassFondosRV',
      props: { default: true },
      component: AssetClassFondosRV,
    },
    {
      path: '/analisis-portafolio/:id/mercado/estructurados',
      name: 'AssetClassEstructurados',
      props: { default: true },
      component: AssetClassEstructurados,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/analisis-portafolio/:id/mercado/capitales',
      name: 'AssetClassCapitales',
      props: { default: true },
      component: AssetClassCapitales,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/analisis-portafolio/:id/mercado/fondosrv/detalle/:assetName',
      name: 'AssetDetail_fondosrv',
      props: { default: true },
      component: AssetDetailFondosRV,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/analisis-portafolio/:id/mercado/fondosrf/detalle/:assetName',
      name: 'AssetDetail_fondosrf',
      props: { default: true },
      component: AssetDetailFondosRF,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/analisis-portafolio/:id/mercado/deuda/detalle/:assetName',
      name: 'AssetDetail_deuda',
      props: { default: true },
      component: AssetDetailDeuda,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/analisis-portafolio/:id/mercado/capitales/detalle/:assetName',
      name: 'AssetDetail_capitales',
      props: { default: true },
      component: AssetDetailCapitales,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/analisis-portafolio/:id/mercado/estructurados/detalle/:assetName',
      name: 'AssetDetail_estructurados',
      props: { default: true },
      component: AssetDetailEstructurados,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/cliente',
      name: 'ClientLogin',
      props: route => ({ query: route.query.portafolio }),
      component: ClientLogin,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/imprimir-analisis-portafolio/:id',
      name: 'PrintablePortfolioAnalysis',
      component: PrintablePortfolioAnalysis
    },
    {
      path: '/links',
      name: 'ImportantLinks',
      component: ImportantLinks
    },

    {
      path: '/validacion',
      name: 'Validacion',
      component: Validacion,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/calculadora',
      name: 'Calculadora',
      component: Calculator
    },

    {
      path: '/calculadora/opcion1',
      name: 'Op1',
      component: Calculator_Op1
    }




  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js